<template>
  <b-card v-if="isPermitted('seeApprovals')">

    <div>
      <b-row>
        <!-- Project -->
        <b-col>
          <v-select
            id="vue-select-project"
            v-model="selectedProject"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionProject"
            :reduce="project => project.id"
            label="projectName"
            :placeholder="$t('All projects')"
            :clearable="false"
            class="mb-2"
          />
        </b-col>
        <!-- Period start -->
        <b-col md="2">
          <v-select
            v-if="selectedProject"
            id="vue-select-period-start"
            v-model="selectedPeriodStart"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionProjectPeriods"
            :clearable="false"
            class="mb-2"
          />

        </b-col>
        <!-- Period end -->
        <b-col md="2">
          <v-select
            v-if="selectedProject"
            id="vue-select-period-end"
            v-model="selectedPeriodEnd"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionProjectPeriods"
            :clearable="false"
            class="mb-2"
          />
        </b-col>
        <!-- Approve Status -->
        <b-col md="2">
          <v-select
            v-if="selectedProject"
            id="vue-select-approval-status"
            v-model="approvalStatus"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionApprovalStatus"
            :clearable="false"
            :reduce="item => item.value"
            class="mb-2"
          />
        </b-col>
        <b-col md="2">
          <b-button
            class="w-100"
            :variant="appliedFilter && appliedFilter.filters.length ? 'success' : 'secondary'"
            @click="hotalertFilter"
          >
            {{ $t('Advanced Filter') }}
          </b-button>
        </b-col>
      </b-row>

      <b-row v-if="appliedFilter && appliedFilter.filters.length">
        <b-col>
          <b-card>
            <span
              v-for="(filterItem, index) in appliedFilter.filters"
              :key="index"
            >
              <template v-if="filterItem.operator">
                {{ filterItem.operator }}
              </template>

              <template v-else>
                <strong class="mr-1">{{ filterItem.filterQuestion.questionText }} = </strong>
                <b-badge
                  v-for="(value, idx) in filterItem.filterValues"
                  :key="idx"
                  variant="primary"
                >{{
                  value.optionText
                }}</b-badge>
                <b-badge
                  v-for="(value, idx) in filterItem.filterValuesText"
                  :key="idx"
                  variant="primary"
                >{{ value
                }}</b-badge>
              </template>
            </span>

          </b-card>

        </b-col>
      </b-row>

      <b-form
        inline
        class="mb-2"
      >

        <b-form-input
          v-model="searchTerm"
          :placeholder="$t('message.SearchPlaceholder')"
          type="text"
          class="d-inline mt-1"
        />

        <b-link
          class="ml-2 mt-1"
          @click="downloadApprovals"
        >
          Download
        </b-link>

      </b-form>

      <!-- table -->
      <vue-good-table
        style-class="vgt-table striped"
        :columns="columns"
        :rows="rows"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'id', type: 'desc' }
        }"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm
        }"
        :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
          mode: 'records',
          perPage: 10,
          perPageDropdown: [10, 50, 100],
          dropdownAllowAll: false,
        }"
      >

        <template
          slot="table-column"
          slot-scope="props"
        >
          <span>
            {{ $t(props.column.label) }}
          </span>
        </template>

        <template
          slot="table-row"
          slot-scope="props"
        >

          <!-- Column: OrjRef -->
          <span
            v-if="props.column.field === 'orjref'"
            class="text-nowrap"
          >
            <b-link @click="view(props.row)">
              {{ props.row.orjref }}
            </b-link>
          </span>

          <!-- Column: createDate -->
          <span
            v-else-if="props.column.field === 'createdate'"
            class="text-nowrap"
          >
            {{ formatDate(props.row.createdate) }}
          </span>
          <!-- Column: closedat -->
          <span
            v-else-if="props.column.field === 'closedat'"
            class="text-nowrap"
          >
            <template v-if="props.row.status === 'Closed'">{{ formatDate(props.row.closedat) }}</template>

            <template v-else />

          </span>

          <!-- Column: assignedDate -->
          <span
            v-else-if="props.column.field === 'assigneddate'"
            class="text-nowrap"
          >
            {{ props.row.assigneddate ? formatDate(props.row.assigneddate) : '-' }}
          </span>

          <!-- Column: actionTakenDate -->
          <span
            v-else-if="props.column.field === 'actiontakendate'"
            class="text-nowrap"
          >
            {{ props.row.actiontakendate ? formatDate(props.row.actiontakendate) : '-' }}
          </span>

          <!-- Column: categories -->
          <span
            v-else-if="props.column.field === 'categories'"
            class="text-nowrap"
          >
            {{ (props.row.categories && props.row.categories.length) ? String(props.row.categories).split('|').join('/')
              : '' }}
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ $t(props.formattedRow[props.column.field]) }}
          </span>
        </template>

      </vue-good-table>

      <modal-survey
        ref="surveyModal"
        :boxid="0"
        :approval-button="approvalButton"
        @approved="approved"
        @notapproved="notapproved"
      />

      <modal-hot-alert-filter
        v-if="selectedProject"
        v-model="filterConfig"
        :project-id="selectedProject"
        @refreshHotalertList="setFilter"
      />

    </div>
  </b-card>
</template>

<script>

import { getUserData, isPermitted } from '@/auth/utils'
import { approvalCount } from '@core/layouts/utils'
import useJwt from '@/auth/jwt/useJwt'
import { VueGoodTable } from 'vue-good-table'
import vSelect from 'vue-select'
import {
  BCard, BForm, BFormInput, BLink, BRow, BCol, BButton, BBadge,
} from 'bootstrap-vue'
import ModalSurvey from '@/layouts/components/ModalSurvey.vue'
import ModalHotAlertFilter from '@/layouts/components/ModalHotAlertFilter.vue'
import dayjs from 'dayjs'

export default {
  components: {
    vSelect,
    BCard,
    BForm,
    BFormInput,
    BRow,
    BCol,
    BLink,
    BButton,
    BBadge,
    VueGoodTable,
    ModalSurvey,
    ModalHotAlertFilter,
  },
  data() {
    return {
      approvalButton: true,
      approvalStatus: 'All Approvals',
      pageLength: 10,
      listColumns: [],
      rows: [],
      searchTerm: '',
      preColumns: [
        {
          label: '#',
          field: 'id',
          type: 'number',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '50px',
        },
        {
          label: 'Survey Id',
          field: 'orjref',
          type: 'number',
        },
        {
          label: 'Create Date',
          field: 'createdate',
        },
        {
          label: 'Approval Reason',
          field: 'hotalertreason',
        },
        {
          label: 'Assigned To',
          field: 'assignedto',
        },
        {
          label: 'Assigned Date',
          field: 'assigneddate',
        },
      ],
      postColumns: [
        {
          label: 'Status',
          field: 'status',
        },
      ],
      columns: [],
      stats: [],
      selectedProject: null,
      optionProject: [],
      optionProjectPeriods: [],
      optionApprovalStatus: [
        { label: this.$t('All Approvals'), value: 'All Approvals' },
        { label: this.$t('Approval'), value: 'Approval' },
        { label: this.$t('Approval Assigned'), value: 'Approval Assigned' },
        { label: this.$t('Not Approved'), value: 'Not Approved' },
        { label: this.$t('Approved'), value: 'Approved' },
      ],
      selectedPeriodStart: null,
      selectedPeriodEnd: null,
      filterConfig: { filters: [] },
      appliedFilter: { filters: [] },
    }
  },
  computed: {
    statslist() {
      if (this.stats) {
        const arr = []
        this.stats.forEach(x => {
          arr.push({
            icon: (x.status.replace('All Hotalerts', 'BellIcon').replace('Assigned', 'UserCheckIcon').replace('Unassigned', 'InfoIcon').replace('Closed', 'CheckCircleIcon')
              .replace('Overdue', 'AlertTriangleIcon')),
            color: (x.status.replace('All Hotalerts', 'primary').replace('Assigned', 'info').replace('Unassigned', 'warning').replace('Closed', 'success')
              .replace('Overdue', 'danger')),
            title: x.statusCount,
            subtitle: x.status,
            size: 12 / this.stats.length,
            customClass: '',
          })
        })
        return arr
      }
      return null
    },
  },
  watch: {
    selectedProject() {
      this.getProjectPeriodOptions()
    },
    selectedPeriodStart() {
      this.loadData()
    },
    selectedPeriodEnd() {
      this.loadData()
    },
    approvalStatus() {
      this.loadData()
    },
  },
  created() {
    this.userData = getUserData()
    this.getProjectOptions()
  },
  methods: {
    isPermitted(code) {
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
    approved(item) {
      useJwt.axiosIns.patch('hotalert/approve', item).then(() => {
        this.$bvModal.hide('modal-survey0')
        this.loadData(true)
      })
    },
    notapproved(item) {
      useJwt.axiosIns.patch('hotalert/notapprove', item).then(() => {
        this.$bvModal.hide('modal-survey0')
        this.loadData(true)
      })
    },
    view(item) {
      // show approve buttons if in (Approval, Approval Assigned)
      this.approvalButton = ['Approval', 'Approval Assigned'].includes(item.status)
      this.$refs.surveyModal.loadSurveyData(item.projectid, item.orjref)
    },
    getProjectOptions() {
      useJwt.axiosIns.get('project').then(response => {
        this.optionProject = response.data.filter(p => p.status)
        if (this.optionProject.length) {
          this.selectedProject = this.optionProject[0].id
          this.getProjectPeriodOptions()
        }
      })
    },
    getProjectPeriodOptions() {
      useJwt.axiosIns.get(`project/${this.selectedProject}/wavelist`).then(response => {
        this.optionProjectPeriods = response.data.sort((a, b) => b - a)
        if (response.data) {
          // eslint-disable-next-line prefer-destructuring
          this.selectedPeriodEnd = response.data[0]
          this.selectedPeriodStart = response.data[response.data.length - 1]
        }
      })
    },
    formatDate(date) {
      return dayjs(date).format('DD.MM.YYYY HH:mm:ss')
    },
    downloadApprovals() {
      useJwt.axiosIns.post(`hotalert/project/${this.selectedProject}/exportxlsx/${this.$i18n.locale}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}/${this.approvalStatus}/approval`, this.appliedFilter, { responseType: 'arraybuffer' })
        .then(response => {
          if (response) {
            this.openFile(response, 'approvals.xlsx')
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    openFile(response, filename) {
      const type = response.headers['content-type']
      const blob = new Blob([response.data], {
        type,
        encoding: 'UTF-8',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      link.remove()
    },
    async loadData() {
      if (this.selectedProject && this.selectedPeriodStart && this.selectedPeriodEnd) {
        this.columns = []
        useJwt.axiosIns.get(`hotalert/project/${this.selectedProject}/approvalcolumns`)
          .then(response => {
            if (response.data) {
              this.listColumns = response.data
            }
            useJwt.axiosIns.post(`hotalert/project/${this.selectedProject}/${this.selectedPeriodStart}/${this.selectedPeriodEnd}/${this.approvalStatus}/approval`, this.appliedFilter)
              .then(async response2 => {
                if (response2.data) {
                  this.rows = response2.data
                  this.columns = [...this.preColumns, ...this.listColumns.map(x => ({ label: x.questionText, field: x.questionName })), ...this.postColumns]
                  await approvalCount()
                  // this.$root.$emit('approval_count', this.rows.length)
                }
              })
              .catch(e => {
                console.log(e)
              })
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    hotalertFilter() {
      this.filterConfig = JSON.parse(JSON.stringify(this.appliedFilter))
      this.$root.$emit('hotalert_filter', this.filterConfig)
    },
    setFilter(filter) {
      this.appliedFilter = JSON.parse(JSON.stringify(filter))
      this.loadData()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
